// 通知等内容字段的格式判断与纯文本提取。
// 内容实际只支持两种形式：富文本 HTML（RichTextEditor 产出）和普通文本。

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i

/**
 * 判断内容是否为富文本 HTML
 * @param {string} content - 原始内容
 * @returns {boolean}
 */
export function isHtmlContent(content) {
  return typeof content === 'string' && HTML_TAG_PATTERN.test(content)
}

/**
 * 去除 HTML 标签，提取纯文本（用于列表摘要等场景）
 * @param {string} content - 原始内容
 * @returns {string}
 */
export function stripHtmlTags(content) {
  if (!content || typeof content !== 'string') return ''
  return content
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .trim()
}
